import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ServicesContainer = styled(motion.div)`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ServiceCard = styled.div`
  background: white;
  padding: 1.5rem;
  margin: 1rem 0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const Services = () => {
  return (
    <ServicesContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <h1>진료 안내</h1>
      <ServiceCard>
        <h2>충치 치료</h2>
        <p>어린이의 충치를 조기에 발견하고 치료합니다.</p>
      </ServiceCard>
      <ServiceCard>
        <h2>예방 치료</h2>
        <p>정기 검진과 불소 도포로 치아 건강을 지킵니다.</p>
      </ServiceCard>
      <ServiceCard>
        <h2>교정 치료</h2>
        <p>성장기 어린이의 치아 교정을 진행합니다.</p>
      </ServiceCard>
    </ServicesContainer>
  );
};

export default Services; 